import { Row, Form, notification, Select } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import FormInput from 'components/FormInput';
import ButtonLink from 'components/theme_components/ButtonLink';
import TextArea from 'antd/lib/input/TextArea';
import { addParTax } from 'services/parametersService';
import ParListSelect from 'components/ParListSelect';
import Notifications from 'components/theme_components/Notifications';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { useContext, useState } from 'react';
import { AuthContext } from 'components/Auth/Auth';

export type ParTaxeModalProps = {
  setVisible: (visible: boolean) => void;
  setAddTaxeValue: (addRateValue: boolean) => void;
  refetch:any;
};

const ParTaxeModal = ({ setVisible, setAddTaxeValue,refetch }: ParTaxeModalProps) => {
  const [form] = useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const { isInspect } = useContext(AuthContext);

  const submit = (values: any) => {
    const req: any = {
      taxcode: values?.taxcode,
      taxlabel: values?.taxlabel,
      taxstatus: 'ACTIVE',
      taxrate: 0,
      taxflow: values.taxflow ?? 'INOUT',
      taxtype: values.taxtype ?? 'TVA',
      taxrateid: 0,
      taxdescription:values.taxdescription ??""
    };
    addParTax({ request: req }).then((response) => {
      if (response.code === '200') {
        Notifications({
          status: "success",
          message: 'La taxe a été créé avec succès',
          description: response.description,
          duration: 3,
          placement: 'top',
        });
        setVisible(false);
        setAddTaxeValue(true);
        refetch()
      } else {
        setModalVisible(true);
      }
    });
  };
  return (
    <Form
      form={form}
      onFinish={(values: any) => {
        submit(values);
      }}
      className="no-border-radius ut-wizard-form"
      layout="vertical"
    >
      <Row gutter={[20, 0]}>
        <FormInput
          col
          xs={24}
          lg={24}
          className="form-item no-border-radius"
          name="taxlabel"
        />

        {/* <FormInput name="taxerate" className="no-border-radius">
            <InputNumber
              formatter={toRate}
              min={0}
              value={text}
              className="no-border-radius ut-wizard-form color-gray"
            />
          </FormInput> */}

        <FormInput
          name="taxtype"
          col
          xs={24}
          lg={24}
          className="form-item no-border-radius"
          rules={[{ required: true }]}
        >
          <ParListSelect parcode="SFSTAXTYPE" aria- />
        </FormInput>
        <FormInput
          col
          xs={24}
          lg={24}
          name="taxflow"
          labelCol={{ span: 24 }}
          className="no-border-radius"
          rules={[{ required: true }]}
        >
          <ParListSelect parcode="TAXFLOW"  />
        </FormInput>
        <FormInput
          col
          xs={24}
          lg={24}
          name="taxdescription"
          labelCol={{ span: 24 }}
          className=""
          rules={[{ required: true }]}
        >
          <TextArea size="middle" rows={3} className="texterea" />
        </FormInput>
      </Row>
      <Row justify={'end'} className="mt-50">
        <ButtonLink
          comcode="Annuler"
          className="ut-btn-bordred"
          onClick={() => setVisible(false)}
        />
        <ButtonLink
          type="primary"
          comcode="Valider"
          htmlType="submit"
          className="ut-reset-btn ml-6"
          iconPosition="end"
        />
      </Row>
      <ConfirmModal
        visible={modalVisible}
        status="error"
        message="Le taux existe déjà"
        description="Voulez-vous le mettre à jour ?"
        onConfirm={() => {
          setModalVisible(false);
        }}
        onCancel={() => !isInspect && setModalVisible(false)}
        className="modalConfirmOrCancel"
      />
    </Form>
  );
};

export default ParTaxeModal;
